const menu = [
  {
    name: "首页",
    path: "/"
  },
  {
    name: "无线校园",
    path: "/wireless"
  },
  {
    name: "智慧校园",
    path: "/school"
  },

  // {
  //   name: "计划",
  //   nameSpan: "image/index/headerMenuX.png",
  //   path: "/xplan"
  // },
  // {
  //   name: "解决方案",
  //   path: "/solution",
  //   type:'3',
  //   children:[
  //     {
  //     name:'无线网络',
  //     icon:'image/solution/wifi-icon.png',
  //     pathList:[{
  //       name:'高校',
  //       path:'/solution'
  //     },{
  //       name:'中职',
  //       path:'/solution'
  //     }
  //       ,{
  //         name:'工厂',
  //         path:'/solution'
  //       },{
  //       name:'工地',
  //       path:'/solution'
  //     }]
  //   },
  //     {
  //     name:'智慧校园',
  //     icon:'image/solution/school_icon.png',
  //     pathList:[{
  //       name:'校园一脸通',
  //       path:'/solutionDetail?id=8'
  //     }]
  //   },{
  //     name:'智慧园区',
  //     icon:'image/solution/factory_icon.png',
  //     pathList:[{
  //       name:'智慧工业园区',
  //       path:''
  //     }]
  //   }]
  // },
  {
    name: "产品中心",
    type:"2",
    path: "/product",
    children: [
      {
        name: "无线网络产品",
        list: [
          {
            name: "智能联接",
            pathList: [
              {
                name: "网关",
                path: "/productDetail?id=1"
              },
              {
                name: "交换机",
                path: "/productDetail?id=2"
              },
              {
                name: "AP",
                path: "/productDetail?id=3"
              },
              {
                name: "OLT",
                path: "/productDetail?id=4"
              },
              {
                name: "ODN",
                path: ""
              }
              ,
              {
                name: "MDU",
                path: "/productDetail?id=6"
              }
              ,
              {
                name: "光AP",
                path: "/productDetail?id=7"
              },
              {
                name: "防代理系统",
                path: "/productDetail?id=30"
              }
            ]
          },
          {
            name: "运营管理",
            pathList: [
              {
                name: "认证计费系统",
                path: "/productDetailSoft?id=8"
              },
              {
                name: "网管系统",
                path: "/productDetailSoft?id=9"
              }
            ]
          },
          {
            name: "高阶辅助",
            pathList: [
              {
                name: "运营中台",
                path: "/productDetailSoft?id=10"
              },
              {
                name: "运维工单",
                path: "/productDetailSoft?id=11"
              },
              {
                name: "客服系统",
                path: "/productDetailSoft?id=27"
              },
              {
                name: "审计系统",
                path: "/productDetailSoft?id=28"
              },
              {
                name: "上网管控",
                path: "/productDetailSoft?id=14"
              },

              {
                name: "CRM系统",
                path: "/productDetailSoft?id=13"
              },
              {
                name: "进销存系统",
                path: "/productDetailSoft?id=12"
              },
            ]
          }
        ]
      },
      {
        name: "智慧校园产品",
        list: [
          {
            name: "智能终端",
            pathList: [
              {
                name: "宿舍水电控设备",
                path: "/productDetail?id=15"
              },
              {
                name: "智能饮用热水设备",
                path: ""
              },
              {
                name: "通道闸机",
                path: ""
              },
              {
                name: "人脸门禁机",
                path: "/productDetail?id=18"
              },
              {
                name: "三刷智能消费机",
                path: "/productDetail?id=19"
              }
              ,
              {
                name: "智能校园视频话机",
                path: "/productDetail?id=20"
              }
              ,
              {
                name: "智能电子学生证",
                path: "/productDetail?id=21"
              }
              ,
              {
                name: "智能电子班牌",
                path: "/productDetail?id=22"
              }
            ]
          },
          {
            name: "运营管理",
            pathList: [
              {
                name: "校园安全系统",
                path: "/productDetailSoft?id=24"
              },
              {
                name: "校园生活系统",
                path: "/productDetailSoft?id=25"
              },
              {
                name: "教务总务系统",
                path: "/productDetailSoft?id=26"
              }
            ]
          }
        ]
      },
      // {
      //   name: "智慧校园产品：",
      // }
    ]
  },
  {
    name: "合作案例",
    path: "/partner",
    type: "1",
    children: [
      {
        name: "无线网络",
        path: "/partner?type=1"
      },
      {
        name: "智慧校园",
        path: "/partner?type=2"
      },
      {
        name: "智慧园区",
        // path: ""
      }
    ]
  },
  {
    name: "新闻动态",
    path: "/news",
    type: "1",
    children: [
      {
        name: "企业动态",
        path: "/news?type=1"
      },
      {
        name: "展会风采",
        path: "/news?type=2"
      },
      {
        name: "行业洞察",
        path: "/news?type=3"
      }
    ]
  },
  {
    name: "关于我们",
    type: "1",
    path: "/about",
    children: [
      {
        name: "公司介绍",
        path: "/about"
      },
      {
        name: "联系我们",
        path: "/contact"
      },
      {
        name: "人才招聘",
        path: "/talent"
      }
    ]
  },


];

export default menu;



// WEBPACK FOOTER //
// ./src/components/header/menu.js